import { FullDashboard } from "lib/entries/types";
import { dashboardPath } from "lib/links/links";
import Link from "next/link";

export const ForkedDashboardCaption: React.FC<{
  dashboard: Pick<FullDashboard, "forked_dashboard">;
}> = ({ dashboard }) => {
  if (!dashboard.forked_dashboard) {
    return null;
  }
  return (
    <span>
      {`forked from `}
      <Link
        href={dashboardPath(
          dashboard.forked_dashboard.owner_handle,
          dashboard.forked_dashboard.dashboard_slug
        )}
      >
        <a>
          @{dashboard.forked_dashboard.owner_handle}/
          {dashboard.forked_dashboard.dashboard_name}
        </a>
      </Link>
    </span>
  );
};
